module.exports = __webpack_public_path__ + "static/flags/WA-d828597640c593139d685116ed1a397c.gif";